//these methods are used when we want to handle the API calls of LNS

import { showError } from "./notify";
import { API_ENDPOINTS as apiEndpoints } from "src/constants/api-endpoints";

export const callApi = async (apiCall) => {
  try {
    let data = await apiCall();
    return handleResponse(data);
  } catch (ex) {
    // showError("Something went wrong, please try again later!");
    // console.log(ex);
    return ex && ex.response ? ex.response : ex;
  }
};

//below function is written for the apis having no data key in the response and the apis which gives different status code on failures
export const callApiWithoutData = async (apiCall) => {
  try {
    let data = await apiCall();
    return handleResponse(data);
  } catch (ex) {
    if (ex && ex.response) {
      return handleResponse(ex.response);
    }
    return ex;
  }
};

function handleResponse(data) {
  // console.log(
  //   data?.config?.baseURL,
  //   data?.config?.url,
  //   apiEndpoints.STORE_CONFIGURATION
  // );
  if (data && data.data && data.data.status) {
    return data;
  } else {
    if (
      data?.data?.message &&
      data.config.url !== apiEndpoints.STORE_CONFIGURATION &&
      !data.config.url.includes("customer/auth/verify-customer")
    ) {
      showError(data.data.message);
    } else if (data?.data?.messages) {
      let errorMessage = [];
      for (let err of Object.values(data.data.messages)) {
        errorMessage.push(err);
      }

      showError(errorMessage.join(","));
    }
    return data;
  }
}

export const callIdentityApi = async (apiCall) => {
  try {
    let resp = await apiCall();
    return resp; //because in Identity when there is any error or intended exception , it will be in catch block
  } catch (ex) {
    if (ex.status == 400) {
      if (ex && ex.data) {
        if (ex.data.errors) {
          let errorMessage = [];
          for (let err of Object.values(ex.data.errors)) {
            errorMessage.push(err);
          }
          let strToshow = errorMessage.join(",").split(",");
          showError([...new Set(strToshow)].join(","));
        } else if (ex.data.message) {
          showError(ex.data.message);
        }
      }
      return ex;
    } else {
      showError("Something went wrong, please try again later!");
      return ex;
    }
  }
};

export const callIdentityApiWithoutErrorMsg = async (apiCall) => {
  try {
    let resp = await apiCall();
    return resp; //because in Identity when there is any error or intended exception , it will be in catch block
  } catch (ex) {
    if (ex.status == 400) {
      if (ex && ex.data) {
        return ex;
      } else {
        return ex;
      }
    }
  }
};
